export const MOUNT_APP = 'MOUNT_APP';
